<div
  [ngClass]="{
    'scrollbar-thumb-white': theme() === 'light',
    'scrollbar-thumb-black': theme() === 'dark',
  }"
  class="flex flex-row items-center gap-4 overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-rounded-full"
>
  @for(category of categories(); track category;) {
    <app-event-category-selector
      [theme]="theme()"
      [category]="category"
      [isSelected]="category === selectedCategory()"
    ></app-event-category-selector>
  }
</div>
